
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { PatientVaccineData, PatientVaccine } from '../../../interfaces/masters/patient-vaccine' ;
import { PatientVaccineApi } from '../api/patient-vaccine.api';
@Injectable()
export class PatientVaccineService extends PatientVaccineData {

    constructor(private api: PatientVaccineApi) {
      super();
    }
  
  
    list(url: string): Observable<PatientVaccine[]> {
      return this.api.list(url);
    }
  
    getById(url:string): Observable<PatientVaccine>{
        return this.api.getById(url);
    }
  
    create(url: string, data:any): Observable<any[]> {
      return this.api.add(url,data);
    }
  
    update(url: string, data:any): Observable<any> {
      return this.api.update(url,data);
    }

    delete(url: string): Observable<boolean> {
      return this.api.delete(url);
    }
  }
  